<script lang="ts">
  import { observeTagOverflow } from "../../../../../../../_shared/_logic/tag-overflow"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import {
    buildRichTooltip,
    tooltipText,
    RICH_TOOLTIP_CLASS,
  } from "../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { ContactOrderPlanRow } from "../../../../_logic/communication-plan-table-contract"

  let overflowing = $state(false)
  let { row }: { row: ContactOrderPlanRow } = $props()
</script>

<span
  class="contact-cell"
  aria-label={row.contact.ariaLabel}
  use:observeTagOverflow={(value) => {
    overflowing = value
  }}
>
  <StatusTag
    variant="neutral"
    size="sm"
    label={row.contact.label}
    subLabel={row.contact.subLabel}
    icon={row.contact.icon}
    color={row.contact.color}
    tooltipContent={buildRichTooltip([
      overflowing
        ? tooltipText([row.contact.label, row.contact.subLabel].filter(Boolean).join(" · "))
        : null,
      row.contact.tooltipHtml,
    ])}
    tooltipHtml={true}
    tooltipClassName={RICH_TOOLTIP_CLASS}
    disableTitle={true}
  />
</span>

<style lang="less">
  .contact-cell {
    display: inline-flex;
    min-width: 0;
    max-width: 25rem;

    :global(.status-tag) {
      max-width: 100%;
    }

    :global(.status-tag__main-label),
    :global(.status-tag__sub-label) {
      max-width: 21rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
